// Plain-English "what changing this does" description for every built-in quote-engine price.
export const PRICE_EFFECT = {
  base_price: "Starting price of every quote — covers design, Building Control & first-fix",
  area_rate_per_sqm: "Multiplied by the floor area (width × depth) of every quote",
  render_rate_per_sqm: "Added per m² of external wall when a rendered finish is picked",
  felt_roof_per_sqm: "Reference only — the felt roof is included in the base build",
  grp_roof_per_sqm: "Added per m² of roof when GRP fibreglass is chosen",
  tiled_roof_saving: "Reference only — pitched-roof tiling is confirmed at survey",
  skylight_each: "Added once for every skylight the customer adds",
  skylight_labour: "Reference only — labour is included in the skylight price",
  roof_lantern_each: "Added once for every roof lantern",
  window_large_surcharge: "Added when the rear window is wider than 800mm",
  extra_window_each: "Added for every additional window beyond the included one",
  bifold_base: "Added once when bifold doors are chosen",
  bifold_per_lm: "Added per metre of bifold opening width, on top of the base",
  hob_gas_surcharge: "Added when a gas hob first-fix is chosen (electric is included)",
  boiler_move: "Added when the customer wants their existing boiler relocated",
  boiler_new: "Not charged — flags the quote for a separate boiler conversation",
  floor_lvt: "One-off base fee when LVT flooring fitting is chosen",
  floor_lvt_per_sqm: "Added per m² of floor when LVT is chosen",
  floor_tiles: "One-off base fee when tiled flooring is chosen",
  floor_tiles_per_sqm: "Added per m² of floor when tiles are chosen",
  kitchen_install: "Added when kitchen installation labour is selected",
  undercabinet_lights: "Added when under-cabinet lights are selected with a kitchen",
  addon_kitchen_removal: "Added when the existing kitchen needs stripping out",
  addon_replaster: "Added when re-plastering the adjoining room is selected",
  addon_reflooring: "Added when re-doing the adjoining room's floor is selected",
  addon_wc: "Added when a WC is selected (suite supplied separately)",
  addon_full_bathroom: "Added when a full bathroom is selected (suite supplied separately)",
  toilet_concealed_surcharge: "Added when a concealed-cistern toilet is picked with a WC/bathroom",
  radiator_each: "Added for every radiator the customer adds",
  underfloor_heating_per_sqm: "Added per m² of floor when electric UFH is selected",
  extra_external_pipe: "Added when an outdoor hot & cold pipe is selected",
  extra_external_socket: "Added per extra outdoor socket",
  extra_wall_light: "Added per extra outdoor light point",
  spotlights_1_6: "Lighting fit-out fee when 1–6 spotlights are chosen",
  spotlights_7_10: "Lighting fit-out fee when 7–10 spotlights are chosen",
  spotlights_11_plus: "Lighting fit-out fee when 11+ spotlights are chosen",
  ulez_per_day: "Multiplied by working days when the site is inside the ULEZ zone",
  rear_access_muckaway: "Added when rear access is only 700–1000mm wide",
  no_driveway_parking_total: "Added when there's no driveway (parking permits)",
  demolish_base: "One-off fee when an existing structure must be demolished",
  demolish_per_sqm: "Added per m² of structure being demolished, on top of the base",
  steel_beam_remove_rear_wall: "Added for the knock-through steel beam (incl. structural calcs)",
  build_over_agreement: "Added when building over a public sewer",
  footings_extra_per_m3: "Charged per m³ if footings must go deeper than 1,200mm (at survey)",
  skip_extra_each: "Charged per skip beyond the four included (at survey)",
};

export const UNIT_EFFECT = {
  fixed: "One-off amount added to the quote when selected",
  each: "Added once per item the customer selects",
  sqm: "Multiplied by the floor area in m²",
  lm: "Multiplied by the length in metres",
};
